export class CircleElementStyleFormatHelper {
    static _targetTexts = {
        "originstoppoint": "Paragem Origem",
        "destinystoppoint": "Paragem Destino",
        "terminalstoppoint": "Paragem Terminal",
        "stoppoint": "Paragem",
        "currentstoppoint": "Paragem Alvo",
        "hiddenstoppoint": "Paragem Escondida",
        "linecolor": "Indicador Cor da Linha"
    }

    static getTargetTextsArray(targetsArray) {
        const output = [];
        
        for(const idx in targetsArray) {
            output.push(this._targetTexts[targetsArray[idx].toLowerCase()]);
        }

        return output;
    }

    static getTargetText(target) {
        return this._targetTexts[target.toLowerCase()];
    }
}
